import React from "react";
import { Modal } from "react-bootstrap";

const RoleConfirmationModal = ({
  show,
  onHide,
  title = "Confirm",
  message = "Are you sure?",
  onConfirm,
  confirmText = "Yes",
  cancelText = "No",
  confirmClass = "license-delete-btn-yes mx-2",
  cancelClass = "license-delete-btn",
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      {title && <Modal.Header closeButton className="license-title">{title}</Modal.Header>}
      <Modal.Body>
        <p className="text-center pt-3">{message}</p>
        <div className="text-center pt-4">
        <button onClick={onConfirm} className={confirmClass}>
          {confirmText}
        </button>
        <button onClick={onHide} className={cancelClass}>
          {cancelText}
        </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RoleConfirmationModal;
